import React, { useEffect, useState } from "react";
import bannerVideo from "../../Images/home.mp4";

const Banner = () => {
  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 700);

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth > 700);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const desktopImg = "https://i.ibb.co/DfyZvND8/Deodorants-for-All.webp";
  const mobileImg = "https://i.ibb.co/zW4jHDwb/Untitled-design-3.png";

  return (
    <div className="w-[100vw]">
      <img
        className="w-[100vw] min-h-[30vh] object-cover"
        alt="Banner"
        src={isDesktop ? desktopImg : mobileImg}
      />
    </div>
  );
};

export default Banner;
